var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    ref: "table",
    staticClass: "q-mt-lg",
    attrs: {
      data: _vm.registrations,
      columns: _vm.columns,
      "row-key": "id",
      pagination: _vm.pagination,
      loading: _vm.loading,
      "no-data-label": _vm.$t("no_data_avaliable"),
      "no-results-label": _vm.$t("no_results_found"),
      "loading-label": _vm.$t("loading_data"),
      "rows-per-page-label": _vm.$t("items_per_page"),
      "rows-per-page-options": [5, 10, 50, 100],
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      },
      request: _vm.requestRegistrations
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            _vm._l(props.cols, function(col) {
              return _c("q-th", { key: col.name, attrs: { props: props } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t(col.label)) +
                    "\n            "
                )
              ])
            }),
            1
          )
        }
      },
      {
        key: "body",
        fn: function(props) {
          return [
            _c(
              "q-tr",
              { attrs: { props: props } },
              [
                _c(
                  "q-td",
                  { key: "group_training_id", attrs: { props: props } },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(props.row.group_training_id) +
                        "\n\t\t\t\t"
                    )
                  ]
                ),
                _c(
                  "q-td",
                  { key: "group_training_title", attrs: { props: props } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(props.row.group_training_title) +
                        "\n                "
                    )
                  ]
                ),
                _c("q-td", { key: "subscribe_date", attrs: { props: props } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.fDate(props.row.subscribe_date)) +
                      "\n                "
                  )
                ]),
                _c(
                  "q-td",
                  {
                    key: "qty_group_training_modules",
                    attrs: { props: props }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          props.row.qty_group_training_modules +
                            props.row.qty_group_training_tests
                        ) +
                        "\n                "
                    )
                  ]
                ),
                _c(
                  "q-td",
                  {
                    key: "qty_group_training_modules_user_watch",
                    attrs: { props: props }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          props.row.qty_group_training_modules_user_watch +
                            props.row.qty_group_training_tests_user_approved
                        ) +
                        "\n                "
                    )
                  ]
                ),
                _c(
                  "q-td",
                  {
                    key: "group_training_user_progress",
                    attrs: { props: props }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(props.row.group_training_user_progress) +
                        "%\n                "
                    )
                  ]
                ),
                _c("q-td", { key: "mandatory", attrs: { props: props } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t(_vm.getMandatory(props.row.mandatory))) +
                      "\n                "
                  )
                ]),
                _c("q-td", { key: "status", attrs: { props: props } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                      "\n                "
                  )
                ])
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }